import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  calendarVisibilityApi,
  type CalendarVisibilityPreferences,
  type PatchCalendarVisibilityInput,
} from '@/api/calendarVisibility';
import { queryKeys } from '@/query/queryKeys';

export const DEFAULT_CALENDAR_VISIBILITY: Omit<
  CalendarVisibilityPreferences,
  'organizationId' | 'userId' | 'updatedAt'
> = {
  showEvents: true,
  showTasks: true,
  showPmsProjects: true,
  showNotes: true,
  showMeetings: true,
  showHolidays: true,
  showOrgEvents: true,
  showAttendance: false,
};

export const useCalendarVisibilityPreferences = () =>
  useQuery({
    queryKey: queryKeys.calendarVisibility(),
    queryFn: () => calendarVisibilityApi.getMine(),
  });

export const usePatchCalendarVisibilityPreferences = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: PatchCalendarVisibilityInput) => calendarVisibilityApi.patchMine(input),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.calendarVisibility(), data);
    },
  });
};
